import React from "react"
import clsx from "clsx"
import styles from "./index.module.scss"

export type CommonLabelStyle =
  | "default"
  | "primary"
  | "secondary"
  | "tertiary"
  | "outline"

export type CommonLabelProps = {
  text: string
  style?: CommonLabelStyle
  color?: string
  bgColor?: string
  borderColor?: string
}

const CommonLabel: React.FC<CommonLabelProps> = ({
  text,
  style = "default",
  color,
  bgColor,
  borderColor,
}) => {
  return (
    <>
      <span
        style={{
          color: color && `${color}`,
          backgroundColor: bgColor && `${bgColor}`,
          borderColor: borderColor && `${borderColor}`,
        }}
        className={clsx([styles.commonLabel, styles[style]])}
      >
        {text}
      </span>
    </>
  )
}

export default CommonLabel
